import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AccountsService } from '../../services/account.service';
import { CommonService } from '../../services/common.service';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.css',
})
export class SideNavComponent implements OnInit  {
  appName?:string|undefined|null='';
  isMobile= false; 
  isSidenavOpen = true; 
  showUserMenu=false;
  showRoleMenu=false;
  showPermissionMenu=false;
  step = signal(0);
  imageLogo='';
  setStep(index: number) {
    this.step.set(index);
  }
  nextStep() {
    this.step.update(i => i + 1);
  }
  prevStep() {
    this.step.update(i => i - 1);
  }
  constructor(
    private observer: BreakpointObserver, 
    private router: Router,
    private accountService: AccountsService,
    private commonService : CommonService,
  ) {

  }

  ngOnInit(): void{
    this.observer.observe(['(max-width: 780px)']).subscribe((screenSize) => {
      if(screenSize.matches){
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });
    this.accountService.toggleSideNavStream.subscribe((state) => {
      this.isSidenavOpen = state;
    });
    this.accountService.currentLogoStream.subscribe(img=>{
      this.imageLogo=img;
    });
    this.accountService.init().subscribe();
    this.appName = localStorage.getItem('appName');
   
  }

  hasPermission(code:string):boolean{
    return this.accountService.hasPermission(code);
  }
 
  async goToHome() {
    if(this.isMobile){
      this.accountService.setToggleSideNav();
    }
    return this.router.navigate(['pages/home']);
  }
  async goToDashboard() {
    if(this.isMobile){
      this.accountService.setToggleSideNav();
    }
    return this.router.navigate(['pages/dashboard']);
  }
  async goToAppInfoList() {
    if(this.isMobile){
      this.accountService.setToggleSideNav();
    }
    return this.router.navigate(['pages/apps/list']);
  }
  async goToUsersList() {
    if(this.isMobile){
      this.accountService.setToggleSideNav();
    }
    return this.router.navigate(['pages/users/list']);
  }
  async goToRolesList() {
    if(this.isMobile){
      this.accountService.setToggleSideNav();
    }
    return this.router.navigate(['pages/roles/list']);
  }
  async goToDevicesList() {
    try {
      if(this.isMobile){
        this.accountService.setToggleSideNav();
      }
      return this.router.navigate(['pages/devices/list']);  
    } catch (error) {
      console.log('route error:', error);
      return;
    }
  }
  async goToVehiclesList() {
    try {
      if(this.isMobile){
        this.accountService.setToggleSideNav();
      }
      return this.router.navigate(['pages/vehicles/list']);  
    } catch (error) {
      console.log('route error:', error);
      return;
    }
  }
  async goToCustomersList() {
    try {
      if(this.isMobile){
        this.accountService.setToggleSideNav();
      }
      return this.router.navigate(['pages/customers/list']);  
    } catch (error) {
      console.log('route error:', error);
      return;
    }
  }
  async goToDistributorsList() {
    try {
      if(this.isMobile){
        this.accountService.setToggleSideNav();
      }
      return this.router.navigate(['pages/distributors/list']);  
    } catch (error) {
      console.log('route error:', error);
      return;
    }
  }
  async goToSimDetailsList() {
    try {
      if(this.isMobile){
        this.accountService.setToggleSideNav();
      }
      return this.router.navigate(['pages/sim-details/list']);  
    } catch (error) {
      console.log('route error:', error);
      return;
    }
  }
  async goToAlarmsList() {
    try {
      if(this.isMobile){
        this.accountService.setToggleSideNav();
      }
      return this.router.navigate(['pages/alarms/list']);  
    } catch (error) {
      console.log('route error:', error);
      return;
    }
  }
  async goToRenewList() {
    try {
      if(this.isMobile){
        this.accountService.setToggleSideNav();
      }
      return this.router.navigate(['pages/licences/list']);  
    } catch (error) {
      console.log('route error:', error);
      return;
    }
  }
  async goToGpsDataList() {
    try {
      if(this.isMobile){
        this.accountService.setToggleSideNav();
      }
      return this.router.navigate(['pages/gps/list']);  
    } catch (error) {
      console.log('route error:', error);
      return;
    }
  }
  async goToPermissionsList() {
    try {
      if(this.isMobile){
        this.accountService.setToggleSideNav();
      }
      return this.router.navigate(['pages/permissions/list']);  
    } catch (error) {
      console.log('route error:', error);
      return;
    }
  }
  async goToAssignDevices(type:string){
    try {
      if(this.isMobile){
        this.accountService.setToggleSideNav();
      }
      const routePath=`pages/assign-device/${type}`;
      return this.router.navigate([routePath]);  
    } catch (error) {
      console.log('route error:', error);
      return;
    }
  }
  async goToTelCompanyList(){
    try {
      if(this.isMobile){
        this.accountService.setToggleSideNav();
      }
      const routePath=`pages/telco/list`;
      return this.router.navigate([routePath]);  
    } catch (error) {
      console.log('route error:', error);
      return;
    }
  }
  async goToEmailTemplateList(){
    try {
      if(this.isMobile){
        this.accountService.setToggleSideNav();
      }
      const routePath=`pages/mail-template/list`;
      return this.router.navigate([routePath]);  
    } catch (error) {
      console.log('route error:', error);
      return;
    }
  }
  
}
